import { render } from "./OptimizationsLibrary.vue?vue&type=template&id=3fa068d0"
import script from "./OptimizationsLibrary.vue?vue&type=script&lang=js"
export * from "./OptimizationsLibrary.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./OptimizationsLibrary.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__